// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip___oWrJ","title":"styles_title__3gB1U","hint":"styles_hint__IBkET"};